<div class="content-body">
  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-12">
        <div class="card bg-transparent shadow-none">
          <div class="card-header flex-wrap border-0 p-0 justify-content-start row">
            <div class="table-tabs me-2 mb-3 me-auto w-100 relative">
              <!-- Floating type icons on the left -->
              <div class="floating-type-tabs">
                <button class="type-btn" *ngIf="!foodtruckOnly" [ngClass]="{active: activeType==='LOCAL'}" (click)="setActiveType('LOCAL')" aria-label="Local">
                  <span class="material-icons">restaurant</span>
                </button>
                <button class="type-btn" *ngIf="!foodtruckOnly" [ngClass]="{active: activeType==='DELIVERY'}" (click)="setActiveType('DELIVERY')" aria-label="Delivery">
                  <span class="material-icons">delivery_dining</span>
                </button>
                <button class="type-btn" *ngIf="!foodtruckOnly" [ngClass]="{active: activeType==='PICKUP'}" (click)="setActiveType('PICKUP')" aria-label="Pickup">
                  <span class="material-icons">storefront</span>
                </button>
                <button class="type-btn" [ngClass]="{active: activeType==='FOODTRUCK'}" (click)="setActiveType('FOODTRUCK')" aria-label="Foodtruck">
                  <span class="material-icons">fastfood</span>
                </button>
              </div>

              <!-- Refresh button -->
              <button mat-icon-button class="refresh-btn" (click)="refreshData()" matTooltip="Actualizar datos">
                <mat-icon>refresh</mat-icon>
              </button>

              <!-- Status tabs aligned with grid (same left padding via .table-tabs) -->
              <div class="status-tabs-bar flex w-full justify-center rounded-lg overflow-hidden border border-gray-200 bg-white">
                <button class="status-tab px-2 py-1 text-center"
                        [class.active]="active===0"
                        (click)="setActive(0)">
                  <span class="tab-label">Todas</span>
                  <span class="tab-count">{{ countAll() }}</span>
                </button>
                <button *ngIf="hasOpen()" class="status-tab px-2 py-1 text-center"
                        [class.active]="active===2"
                        (click)="setActive(2)">
                  <span class="tab-label">Abiertas</span>
                  <span class="tab-count">{{ countOpenLike() }}</span>
                </button>
                <button *ngIf="hasClosed()" class="status-tab px-2 py-1 text-center"
                        [class.active]="active===3"
                        (click)="setActive(3)">
                  <span class="tab-label">Cerradas</span>
                  <span class="tab-count">{{ countBy('CLOSED') }}</span>
                </button>
                <button *ngIf="hasPaymentPending()" class="status-tab px-2 py-1 text-center"
                        [class.active]="active===4"
                        (click)="setActive(4)">
                  <span class="tab-label">Por pagar</span>
                  <span class="tab-count">{{ countBy('PAYMENT_PENDING') }}</span>
                </button>
              </div>
            </div>
          </div>

  <!-- Mobile grid of cards -->
  <div class="tables-grid mt-3">
    <ng-container *ngFor="let table of tables">
      <div *ngIf="passesFilters(table)" class="card-wrapper">
        <app-order-card
          [tableName]="table.name"
          [orderId]="table.orderId ?? ''"
          [date]="table.updatedAt ? table.updatedAt : (table.createdAt ? table.createdAt : '')"
          [status]="table.status"
          [customerName]="table.customerName"
          [items]="table.items"
          [priceSummary]="table.priceSummary"
          [paymentSummary]="table.paymentSummary"
          (clicked)="onSelectTable(table.uuid)"
        ></app-order-card>
        <div class="card-actions">
          <button mat-icon-button color="primary" (click)="onEditTable(table.uuid)" matTooltip="Editar mesa" aria-label="Editar mesa">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" [disabled]="isDeleting(table.uuid)" (click)="onDeleteTable(table.uuid)" matTooltip="Borrar mesa" aria-label="Borrar mesa">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
